import type { DebtAsset } from "~/types/assets.types";
import { calculatePortionFromDebt } from "./portionFromDebt";

export const calculateDebtWeightedInterest = (userProduct: DebtAsset) => {
  const routes = userProduct?.routesData || [];
  const portions = calculatePortionFromDebt(userProduct);

  return routes.reduce((sum, current, index) => {
    const interest = current?.interest || 0;
    const portion = portions?.[index] || 0;

    return sum + interest * portion;
  }, 0);
};
